export default [
  {
    path: '/dashboard/commercial-proposals',
    name: 'CommercialProposalsList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/CommercialProposals/CommercialProposalListView.vue')
  },
  {
    path: '/dashboard/commercial-proposals/create',
    name: 'CreateCommercialProposal',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/CommercialProposals/CreateCommercialProposalView.vue')
  },
  {
    path: '/dashboard/commercial-proposals/:id',
    name: 'EditCommercialProposal',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/CommercialProposals/EditCommercialProposalView.vue')
  }
]
